"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decrypt = exports.encrypt = exports.importKey = exports.ensureKeyHex = exports.generateKey = void 0;
var encoders_1 = require("./encoders");
var ALGORITHM = { name: 'AES-CBC', length: 256 };
var IV_LENGTH_BYTES = 16;
var KEY_LENGTH_BYTES = 32;
var KEY_HEX_LENGTH = KEY_LENGTH_BYTES * 2;
var KEY_HEX_PATTERN = new RegExp("^[0-9a-fA-F]{".concat(KEY_HEX_LENGTH, "}$"));
var generateKey = function (input) { return __awaiter(void 0, void 0, void 0, function () {
    var encoder, password, salt, keyMaterial, derivedBits, derivedKey, key, exported;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (input && KEY_HEX_PATTERN.test(input)) {
                    (0, exports.ensureKeyHex)(input);
                    return [2 /*return*/, input];
                }
                if (!input) return [3 /*break*/, 3];
                encoder = new TextEncoder();
                password = encoder.encode(input);
                salt = encoder.encode('audroam');
                return [4 /*yield*/, crypto.subtle.importKey('raw', password, 'PBKDF2', false, ['deriveBits'])];
            case 1:
                keyMaterial = _a.sent();
                return [4 /*yield*/, crypto.subtle.deriveBits({
                        name: 'PBKDF2',
                        salt: salt,
                        iterations: 100000,
                        hash: 'SHA-256'
                    }, keyMaterial, 256)];
            case 2:
                derivedBits = _a.sent();
                derivedKey = new Uint8Array(derivedBits);
                return [2 /*return*/, Array.from(derivedKey)
                        .map(function (byte) { return byte.toString(16).padStart(2, '0'); })
                        .join('')];
            case 3: return [4 /*yield*/, crypto.subtle.generateKey(ALGORITHM, true, ['encrypt', 'decrypt'])];
            case 4:
                key = _a.sent();
                return [4 /*yield*/, crypto.subtle.exportKey('raw', key)];
            case 5:
                exported = _a.sent();
                return [2 /*return*/, Array.from(new Uint8Array(exported))
                        .map(function (byte) { return byte.toString(16).padStart(2, '0'); })
                        .join('')];
        }
    });
}); };
exports.generateKey = generateKey;
var ensureKeyHex = function (keyHex) {
    if (!KEY_HEX_PATTERN.test(keyHex)) {
        throw new Error("Key must be a ".concat(KEY_HEX_LENGTH, "-character hex string (").concat(KEY_LENGTH_BYTES * 8, " bits)."));
    }
};
exports.ensureKeyHex = ensureKeyHex;
var importKey = function (keyHex) { return __awaiter(void 0, void 0, void 0, function () {
    var keyData, i;
    return __generator(this, function (_a) {
        (0, exports.ensureKeyHex)(keyHex);
        keyData = new Uint8Array(KEY_LENGTH_BYTES);
        for (i = 0; i < KEY_LENGTH_BYTES; i++) {
            keyData[i] = parseInt(keyHex.slice(i * 2, i * 2 + 2), 16);
        }
        return [2 /*return*/, crypto.subtle.importKey('raw', keyData, ALGORITHM, false, ['encrypt', 'decrypt'])];
    });
}); };
exports.importKey = importKey;
var encrypt = function (plainText, keyHex, encoder) {
    if (encoder === void 0) { encoder = encoders_1.defaultEncoder; }
    return __awaiter(void 0, void 0, void 0, function () {
        var key, iv, encrypted, combined;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, exports.importKey)(keyHex)];
                case 1:
                    key = _a.sent();
                    iv = crypto.getRandomValues(new Uint8Array(IV_LENGTH_BYTES));
                    return [4 /*yield*/, crypto.subtle.encrypt({ name: 'AES-CBC', iv: iv }, key, new TextEncoder().encode(plainText))];
                case 2:
                    encrypted = _a.sent();
                    combined = new Uint8Array(IV_LENGTH_BYTES + encrypted.byteLength);
                    combined.set(iv);
                    combined.set(new Uint8Array(encrypted), IV_LENGTH_BYTES);
                    return [2 /*return*/, encoder.encode(combined.buffer)];
            }
        });
    });
};
exports.encrypt = encrypt;
var decrypt = function (payload, keyHex, encoders) {
    if (encoders === void 0) { encoders = [encoders_1.defaultEncoder]; }
    return __awaiter(void 0, void 0, void 0, function () {
        var combined, key, iv, ciphertext, decrypted;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    (0, exports.ensureKeyHex)(keyHex);
                    combined = (0, encoders_1.decodeWithFallbacks)(payload, encoders);
                    if (combined.byteLength < IV_LENGTH_BYTES + 1) {
                        throw new Error('Payload too short to contain IV and ciphertext');
                    }
                    return [4 /*yield*/, (0, exports.importKey)(keyHex)];
                case 1:
                    key = _a.sent();
                    iv = combined.slice(0, IV_LENGTH_BYTES);
                    ciphertext = combined.slice(IV_LENGTH_BYTES);
                    return [4 /*yield*/, crypto.subtle.decrypt({ name: 'AES-CBC', iv: iv }, key, ciphertext)];
                case 2:
                    decrypted = _a.sent();
                    return [2 /*return*/, new TextDecoder().decode(decrypted)];
            }
        });
    });
};
exports.decrypt = decrypt;
